<template>
  <div class="content-wrapper">
    <div class="container">
      <article>
        <section class="section white-panel pt20 pr0 pl0">
          <div class="bdb-solid-gray3 ml4p">
            <h2 class="fs16 font-weight-bold mr4p">利用について</h2>
          </div>
          <dl>
            <dt class="toggle-open fs14 pl4p pr10p pt12 pb12 font-weight-bold">機械・手洗い洗車とは何ですか?</dt>
            <dd class="child fs14 color-font2 pl4p pr4p">
              <span class="pt12 pb12 inline-block">お客様からお車をお預かりし、洗車から拭き上げまで全てSSスタッフが行う洗車サービスです。</span>
            </dd>
          </dl>
          <hr class="hr-solid-gray ml4p mt0 mb0">
          <dl>
            <dt class="toggle-open fs14 pl4p pr10p pt12 pb12 font-weight-bold">ドライブスルー洗車とは何ですか?</dt>
            <dd class="child fs14 color-font2 pl4p pr4p">
              <span class="pt12 pb12 inline-block">洗車機の利用・拭き上げはお客様ご自身で行っていただく洗車サービスです。</span>
            </dd>
          </dl>
          <hr class="hr-solid-gray ml4p mt0 mb0">
          <dl>
            <dt class="toggle-open fs14 pl4p pr10p pt12 pb12 font-weight-bold">1回いくらですか?</dt>
            <dd class="child fs14 color-font2 pl4p pr4p">
              <span class="pt12 pb12 inline-block">ご利用店舗・メニューにより異なります。詳しくはSSスタッフにご確認ください。</span>
            </dd>
          </dl>
          <hr class="hr-solid-gray ml4p mt0 mb0">
          <dl>
            <dt class="toggle-open fs14 pl4p pr10p pt12 pb12 font-weight-bold">利用するSSを変更できますか?</dt>
            <dd class="child fs14 color-font2 pl4p pr4p">
              <span class="pt12 pb12 inline-block">変更できませんので購入時にご留意ください。</span>
            </dd>
          </dl>
          <hr class="hr-solid-gray ml4p mt0 mb0">
          <dl>
            <dt class="toggle-open fs14 pl4p pr10p pt12 pb12 font-weight-bold">現金との併用はできますか?</dt>
            <dd class="child fs14 color-font2 pl4p pr4p">
              <span class="pt12 pb12 inline-block">現金との併用はできませんので、残高が不足している場合はチャージをしてご利用ください。</span>
            </dd>
          </dl>
          <div class="bdb-solid-gray3 ml4p pt28">
            <h2 class="fs16 font-weight-bold mr4p">チャージについて</h2>
          </div>

          <dl>
            <dt class="toggle-open fs14 pl4p pr10p pt12 pb12 font-weight-bold">チャージとは何ですか?</dt>
            <dd class="child fs14 color-font2 pl4p pr4p">
              <span class="pt12 pb12 inline-block">洗車サービス専用で使えるポイントを購入することです。<br>
アプリにクレジットカード情報をご登録・お支払いいただきます。(現金でのお支払いはできません) <br>お得にポイントを購入することができます</span>
            </dd>
          </dl>
          <hr class="hr-solid-gray ml4p mt0 mb0">
          <dl>
            <dt class="toggle-open fs14 pl4p pr10p pt12 pb12 font-weight-bold">最大でいくらまでチャージできますか?</dt>
            <dd class="child fs14 color-font2 pl4p pr4p">
              <span class="pt12 pb12 inline-block">最大チャージ可能額は240,000円分です。</span>
            </dd>
          </dl>

          <div class="bdb-solid-gray3 ml4p pt28">
            <h2 class="fs16 font-weight-bold mr4p">その他</h2>
          </div>

          <dl>
            <dt class="toggle-open fs14 pl4p pr10p pt12 pb12 font-weight-bold">機種変をしたときに残っているポイントはどうなりますか</dt>
            <dd class="child fs14 color-font2 pl4p pr4p">
              <span class="pt12 pb12 inline-block">ご登録いただいたメールアドレスにてチャージ残高の引継が可能です。</span>
            </dd>
          </dl>
          <hr class="hr-solid-gray ml4p mt0 mb0">
          <dl>
            <dt class="toggle-open fs14 pl4p pr10p pt12 pb12 font-weight-bold">引っ越しにより使わなくなったため返金したい</dt>
            <dd class="child fs14 color-font2 pl4p pr4p">
              <span class="pt12 pb12 inline-block">チャージ完了後に、チャージのキャンセルや残高の払い戻しはできません。</span>
            </dd>
          </dl>
          <hr class="hr-solid-gray ml4p mt0 mb0">
          <dl>
            <dt class="toggle-open fs14 pl4p pr10p pt12 pb12 font-weight-bold">ポイントの有効期限はありますか?</dt>
            <dd class="child fs14 color-font2 pl4p pr4p">
              <span class="pt12 pb12 inline-block">購入日より180日となります。</span>
            </dd>
          </dl>
        </section>

      </article>
    </div>

  </div>
</template>

<script>

export default {
  data () {
    return {
    }
  },
  methods: {
  },
  computed: {
  },
  async mounted () {
    // 戻るボタンの出し分け
    this.appDisplayBack(true)

    // [eventTrack]
    this.nativePVset('CARWASH_FAQ')

    /* eslint-disable*/
    $(function () {
      $('.dl-toggle > .child').hide(),
      $('.dl-toggle').click(function (t) {
        $(this).toggleClass('open'),
        $('.child', this).slideToggle(500)
      }),
      $('.toggle-open').next().hide(),
      $('.toggle-open').click(function (t) {
        $(this).toggleClass('open'),
        $(this).next().slideToggle(500)
      })
    })
    /* eslint-enable */
  },
  components: {
  }
}
</script>
